import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import Button from 'react-scale/components/ui/button';

const EventsBanner = ({ date, title, speakers, cta }) => (
  <div className="text-white bg-black border-b border-gray-800">
    <div className="container">
      <div className="flex flex-col items-center gap-4 py-3 text-sm sm:flex-row sm:justify-between">
        <Link href={cta.href}>
          <a>
            <SpeakerBanner title={title} date={date} speakers={speakers} />
          </a>
        </Link>
        <div className="hidden sm:block">
          <Button text={cta.text} href={cta.href} variant={cta.variant} size={cta.size} />
        </div>
      </div>
    </div>
  </div>
);

const SpeakerBanner = ({ title, date, speakers }) => (
  <div className="flex items-start gap-4 sm:items-center">
    <div className={cn({ 'flex ml-1 pr-1': speakers.length > 1 })}>
      {speakers.map(speaker => (
        <div
          className={cn(
            'relative w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden shadow-sm mt-1 sm:mt-0',
            { '-mx-1': speakers.length > 1 }
          )}
        >
          <Image src={speaker.image} alt={speaker.alt} layout="fill" priority />
        </div>
      ))}
    </div>
    <div className="flex flex-wrap">
      <span>
        <span className="text-gradient">{date}</span> {title}&nbsp;
      </span>
      <span>
        <span className="text-gray-400">by</span>&nbsp;
        {speakers.map((speaker, i) => (
          <>
            {speaker.name}{' '}
            {speakers.length > 1 && i !== speakers.length - 1 && (
              <span className="text-gray-400">and&nbsp;</span>
            )}
          </>
        ))}
      </span>
    </div>
  </div>
);

EventsBanner.defaultProps = {
  date: 'Thursday March 17th - 12 PM PT:',
  title: 'Buildering Autonomous Vehicles from the ground-up',
  cta: {
    text: 'RSVP Now',
    href: '/',
    variant: 'primary',
    size: 'small'
  }
};

export default EventsBanner;
